import React, { useContext } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { CogIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import { validateYup } from "../template-info/templateUtils"
import * as yup from "yup"
import { Header } from "../common/header"
import { getCookie } from "../../helper/auth"

export const AddWhatsAppConfig = ({ hubId, onAddWhatsAppConfig }) => {
	const [form, setForm] = React.useState({
		userId: "",
		password: "",
		phone: "",
		name: ""
	})
	const [loading, setLoading] = React.useState(false)
	const [errors, setErrors] = React.useState({})

	const addWhatsAppConfig = () => {
		let schema = yup.object().shape({
			userId: yup.string().trim().required("Required"),
			password: yup.string().trim().required("Required"),
			name: yup
				.string()
				.trim()
				.required("Required")
				.matches(
					/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
					"Only alphabets are allowed for this field "
				),
			phone: yup
				.string()
				.trim()
				.required("Required")
				.matches(
					/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
					"Only alphabets are allowed for this field "
				)
		})
		validateYup(schema, form)
			.then(() => {
				setErrors({})
				setLoading(true)
				;(async () => {
					const token = getCookie("token")
					await axiosInstance.post(
						EndpointConfig.hubWhatsAppConfig,
						{
							userId: form.userId,
							password: form.password,
							phone: form.phone,
							name: form.name
						},
						{
							headers: {
								Authorization: `Bearer ${token}`
							}
						}
					)
					toast("Added Successfully")
					setForm({
						userId: "",
						password: "",
						phone: "",
						name: ""
					})
					onAddWhatsAppConfig?.()
				})()
					.catch(console.err)
					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	return (
		<div className="flex flex-col">
			<Header IconName={CogIcon} subText={"Setup"} mainText={"Add WhatsApp Configurations"} />
			<div className="flex flex-col gap-1 p-4 bg-white rounded">
				<div className="flex flex-row gap-6">
					<Input
						name="name"
						error={errors?.name}
						value={form.name}
						label={"Record Name"}
						placeholder={"WhatsApp Config - 1"}
						onChange={(e) => setForm({ ...form, name: e.target.value })}
					/>
					<Input
						name="phone"
						error={errors?.phone}
						value={form.phone}
						label={"Phone"}
						placeholder={"Phone Number"}
						onChange={(e) => setForm({ ...form, phone: e.target.value })}
					/>
				</div>
				<div className="flex flex-row gap-6">
					<Input
						name="userId"
						error={errors?.userId}
						value={form.userId}
						label={"User Id"}
						placeholder={"User Id"}
						onChange={(e) => setForm({ ...form, userId: e.target.value })}
					/>
					<Input
						name="password"
						error={errors?.password}
						value={form.password}
						label={"Password"}
						placeholder={"Password"}
						onChange={(e) => setForm({ ...form, password: e.target.value })}
					/>
				</div>
				<div className="flex flex-row gap-6">
					<div className="flex-[3]">&nbsp;</div>
					<div className="flex-1">
						&nbsp;
						{loading ? (
							<Button className="w-full text-black bg-red-100 pointer-events-none ">
								Loading
							</Button>
						) : (
							<Button className="w-full " onClick={addWhatsAppConfig}>
								Add
							</Button>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
